import { ADMIN } from '@/utils/roles'

export default [
  {
    path: '/lab/list',
    name: 'lab-list',
    component: () => import('@/views/labs/LabList.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Lab List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Lab' }, { title: 'Lab List', active: true }],
      roles: [ADMIN]
    }
  },
  {
    path: '/lab/create',
    name: 'create-lab',
    component: () => import('@/views/labs/CreateLab.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Create Lab',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Lab List', url: '/lab/list' },
        { title: 'Create Lab', active: true }
      ],
      roles: [ADMIN]
    }
  },
  {
    path: '/lab/:id/edit',
    name: 'edit-lab',
    component: () => import('@/views/labs/EditLab.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Edit Lab',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Lab List', url: '/lab/list' },
        { title: 'Edit Lab', active: true }
      ],
      roles: [ADMIN]
    }
  },
  {
    path: '/labs/:labId/products/list',
    name: 'lab-products-list',
    component: () => import('@/views/labs/product/LabProductList.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Lab Products',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Lab List', url: '/lab/list' },
        { title: 'Lab Products List', active: true }
      ],
      roles: [ADMIN]
    }
  },
  {
    path: '/labs/:labId/products/create',
    name: 'create-lab-product',
    component: () => import('@/views/labs/product/CreateLabProduct.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Create Lab Products',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Lab List', url: '/lab/list' },
        { title: 'Create Lab Products', active: true }
      ],
      roles: [ADMIN]
    }
  },
  {
    path: '/labs/:labId/products/:id/edit',
    name: 'edit-lab-product',
    component: () => import('@/views/labs/product/EditLabProduct.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Edit Lab Products',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Lab List', url: '/lab/list' },
        { title: 'Create Lab Products', active: true }
      ],
      roles: [ADMIN]
    }
  }
]
